import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';

import {
  perPageFilterDataDesktop,
  perPageFilterDataTablet,
  perPageFilterDataMobile,
} from '../../../../../data/directory/publications/publications';

import useSizes from '../../../../../hooks/sizes';
import ConditionalTooltip from '../../../../UKPrivateCompanyInsights/CommonComponent/ConditionalTooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const PerPage = ({
  selectedValue, setSelectedValue, skipMobileValues = false,
  fixedSizeFilterData = [], isDisable,
  labelClassName = '', rounded = false,
  tooltipProps, tooltipMessage, tooltipDisable = false,
}) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [perPageValue, setPerPageValue] = useState(
    fixedSizeFilterData.length ? fixedSizeFilterData : perPageFilterDataDesktop,
  );
  const { width } = useSizes();
  const toggleDropdown = () => {
    if (isDisable) return;
    setFilterOpen((filterOpen) => !filterOpen);
  };

  useEffect(() => {
    if (fixedSizeFilterData.length) return;
    if (width > 1024) {
      setPerPageValue(perPageFilterDataDesktop);
    } else if (width >= 768 || skipMobileValues) {
      setPerPageValue(perPageFilterDataTablet);
    } else {
      setPerPageValue(perPageFilterDataMobile);
    }
  }, [width, skipMobileValues]);

  return (
    <div className={cx('perPage__container')}>
      <div className={cx('perPage__label', labelClassName)}>
        Show Per Page:
      </div>
      <ConditionalTooltip
        tooltipProps={tooltipProps}
        tooltipMessage={tooltipMessage}
        showTooltip={tooltipDisable}
      >
        <div className={cx('perPage__dropdown', { disable: isDisable })}>
          <Dropdown
            id={cx('perPage__dropdown--container')}
            onToggle={toggleDropdown}
            show={filterOpen}
            disabled={isDisable}
          >
            <Dropdown.Toggle className={cx({ rounded })}>
              <div className={cx('perPage__dropdown--title')}>
                {selectedValue}
              </div>
              <div className={cx('perPage__dropdown--arrow')}>
                <FontAwesomeIcon icon={filterOpen ? faChevronUp : faChevronDown} />
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu
              rootCloseEvent="click"
              flip={false}
              show={filterOpen}
              className={cx({ rounded })}
            >
              {
                perPageValue?.map(({ id, label, value }, index) => (
                  <Options
                    key={id}
                    label={label}
                    value={value}
                    selectedValue={selectedValue}
                    onSelect={setSelectedValue}
                    index={index}
                    filterOpen={filterOpen}
                    rounded={rounded && (index === 0 || index === perPageValue.length - 1)}
                  />
                ))
              }
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </ConditionalTooltip>
    </div>
  );
};

const Options = ({
  label, value,
  selectedValue,
  onSelect, index,
  filterOpen, rounded,
}) => (
  <Dropdown.Item
    eventKey={value}
    active={+value === +selectedValue}
    onSelect={onSelect}
    className={cx({ rounded })}
  >
    <div className={cx('option--title')}>
      {label}
    </div>
    {(index === 0 && filterOpen) && (
      <div className={cx('option--arrow')}>
        <FontAwesomeIcon icon={faChevronUp} />
      </div>
    )}
  </Dropdown.Item>
);

export default PerPage;
